import { z } from "zod";
import { VENDOR_KEY_REGEX } from "../lib/constants";
import { BatchPrintPreferenceSchema, ShippingDocumentsContentDisposition } from "./enums/batch-print.enum";

export const VendorPropertiesSchema = z.object({
  bccBeta: z.boolean().optional(),
  labelPrintEnabledCustomerAccountNumbers: z.array(z.string()).optional(),
  batchPrintPreference: BatchPrintPreferenceSchema.optional(),
  sendOrderToVendorSystemBeforeFulfillment: z.boolean().optional(),
  blpPilotTestWebOrderNumbers: z.array(z.string()).optional(),
  customPackingSlipEnabled: z.boolean().optional(), // If enabled, the system will use custom packing slips for all FTBP orders
  shippingDocumentsContentDisposition: ShippingDocumentsContentDisposition.optional(),
  labelExportUrlStyle: z.enum(["pre-signed", "pre-signed-with-auto-redirect", "ship-hero"]).optional(),
  includePreSignedUrlInExport: z.boolean().optional(),
  defaultPrintSize: z.enum(["A6", "A4", "Letter", "4x6", "3x4"]).optional(), // Default paper size for PDF printing
  defaultGroupBySettings: z.array(z.enum(["product", "grind", "quantity"])).optional(), // Default group by settings for shipping documents dialog
});

export const vendorSchema = z.object({
  id: z.string().trim().min(1, "id is required"),
  type: z.literal("vendor"),
  region: z.string().trim().min(1, "region is required"),
  vendorKey: z
    .string()
    .trim()
    .min(1, "vendorKey is required")
    .regex(new RegExp(VENDOR_KEY_REGEX, "i"), { message: "vendorKey is invalid" }),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  vendorName: z.string().nullable().optional(),
  email: z.string().email().nullable().optional(),
  userId: z.string().optional(),
  contactId: z.string().optional(),
  properties: VendorPropertiesSchema.optional(),
});

export type VendorProperties = z.infer<typeof VendorPropertiesSchema>;
export type Vendor = z.infer<typeof vendorSchema>;
